'use client';

import { AtomicContext } from '@contexts/coveo/AtomicContext';
import { AtomicBreadbox, AtomicRefineToggle } from '@coveo/atomic-react';
import { AtomicFilters } from './AtomicFilters';
import { ResultsPerPage } from './ResultsPerPage';
import { Sorting } from './Sorting';

const mobileStyles = `
atomic-refine-toggle::part(button) {
    border-color: var(--atomic-on-background);
    border-width: 2px;
    border-radius: var(--atomic-border-radius-full);
    font-size: var(--atomic-text-lg);
    color: var(--atomic-on-background);
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.18rem;
}
`;

export const AtomicQueryRefinement = ({
  context,
}: {
  context: AtomicContext;
}) => {
  return (
    <>
      <section className="block text-sm lg:hidden">
        <style>{mobileStyles}</style>
        <AtomicRefineToggle collapseFacetsAfter={-1} />
      </section>
      <section className="hidden lg:block">
        <div className="mb-2 flex flex-wrap justify-between gap-2 lg:mb-6">
          <AtomicFilters context={context} />
          <div className="flex gap-x-2">
            <Sorting context={context} />
            <ResultsPerPage context={context} />
          </div>
        </div>
      </section>
      <AtomicBreadbox className="mt-8 lg:mt-0" />
    </>
  );
};
